import { Address } from "./address";
import { StaffPractitionerSupport } from "./staffPractitionerSupport";


export class StaffDetails {
  staffUserId: number;
  name: string;
  phoneNumber: string;
  email: string;
  role: string;
  healthSystemIds: number[] = [];
  address: Address = new Address;
  staffPractitionerSupport: StaffPractitionerSupport[] = [];
}
